export const dummyData = [
  {
    symbol: "BTCUSDC",
    orderId: "C02__478475768075210754102",
    orderListId: -1,
    clientOrderId: "",
    price: "71445.39",
    origQty: "0.001",
    executedQty: "0",
    cummulativeQuoteQty: "0",
    status: "CANCELED",
    timeInForce: "",
    type: "LIMIT",
    side: "BUY",
    stopPrice: "",
    icebergQty: "",
    time: 1729859749000,
    updateTime: 1729859749000,
    isWorking: true,
    origQuoteOrderQty: "0",
  },
  {
    symbol: "BTCUSDC",
    orderId: "C02__478475103760371713102",
    orderListId: -1,
    clientOrderId: "",
    price: "71441.96",
    origQty: "0.001",
    executedQty: "0",
    cummulativeQuoteQty: "0",
    status: "CANCELED",
    timeInForce: "",
    type: "MARKET",
    side: "BUY",
    stopPrice: "",
    icebergQty: "",
    time: 1729859590000,
    updateTime: 1729859590000,
    isWorking: true,
    origQuoteOrderQty: "0",
  },
  {
    symbol: "BTCUSDC",
    orderId: "C02__478472855605035012102",
    orderListId: -1,
    clientOrderId: "",
    price: "71410.48",
    origQty: "0.001",
    executedQty: "0",
    cummulativeQuoteQty: "0",
    status: "CANCELED",
    timeInForce: "",
    type: "MARKET",
    side: "BUY",
    stopPrice: "",
    icebergQty: "",
    time: 1729859054000,
    updateTime: 1729859054000,
    isWorking: true,
    origQuoteOrderQty: "0",
  },
  {
    symbol: "BTCUSDC",
    orderId: "C02__478466958585565184102",
    orderListId: -1,
    clientOrderId: "",
    price: "71518.88",
    origQty: "0.001",
    executedQty: "0",
    cummulativeQuoteQty: "0",
    status: "CANCELED",
    timeInForce: "",
    type: "LIMIT",
    side: "BUY",
    stopPrice: "",
    icebergQty: "",
    time: 1729857648000,
    updateTime: 1729857648000,
    isWorking: true,
    origQuoteOrderQty: "0",
  },
  {
    symbol: "BTCUSDC",
    orderId: "C02__478461323416510464102",
    orderListId: -1,
    clientOrderId: "",
    price: "71343.31",
    origQty: "0.001",
    executedQty: "0",
    cummulativeQuoteQty: "0",
    status: "CANCELED",
    timeInForce: "",
    type: "MARKET",
    side: "BUY",
    stopPrice: "",
    icebergQty: "",
    time: 1729856305000,
    updateTime: 1729856305000,
    isWorking: true,
    origQuoteOrderQty: "0",
  },
];

export const BTC_PAIR_COINS = [
  { symbol: "BTCUSDT", title: "BTC/USDT", name: "" },
  { symbol: "BTCBNB", title: "BTC/BNB", name: "" },
  { symbol: "BTCETH", title: "BTC/ETH", name: "" },
  { symbol: "BTCBUSD", title: "BTC/BUSD", name: "" },
  { symbol: "BTCUSDC", title: "BTC/USDC", name: "" },
  { symbol: "BTCTUSD", title: "BTC/TUSD", name: "" },
  { symbol: "BTCGBP", title: "BTC/GBP", name: "" },
  { symbol: "BTCJPY", title: "BTC/JPY", name: "" },
  { symbol: "BTCHF", title: "BTC/HF", name: "" },
];

export const USDT_PAIR_COINS = [
  { symbol: "BTCUSDT", title: "USDT/BTC", name: "" },
  { symbol: "BTCBNB", title: "USDT/ETH", name: "" },
  { symbol: "BTCETH", title: "USDT/BNB", name: "" },
  { symbol: "BTCBUSD", title: "USDT/ADA", name: "" },
  { symbol: "BTCUSDC", title: "USDT/XRP", name: "" },
  { symbol: "BTCTUSD", title: "USDT/SOL", name: "" },
  { symbol: "BTCGBP", title: "USDT/DOGE", name: "" },
  { symbol: "BTCJPY", title: "USDT/DOT", name: "" },
  { symbol: "BTCHF", title: "USDT/MATIC", name: "" },
];
